function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.995 5.585a3.185 3.185 0 0 0-.877 1.64 3.201 3.201 0 0 0-4.477 2.057L8.813 4.454A3.2 3.2 0 1 0 4.287 8.98l11.041 11.04-3.12-.836a3.2 3.2 0 0 0-1.657 6.182c.393.106 1.906.51 2.222.596 2.413.652 5.316 2.945 7.735 3.595 3.376.908 8.264 1.663 8.541 1.708a.8.8 0 1 0 .257-1.58c-.272-.043-5.599-.916-8.389-1.674-1.895-.515-5.105-2.903-7.73-3.595-.316-.083-1.829-.49-2.222-.595a1.6 1.6 0 1 1 .828-3.091l5.783 1.55c.614.216 1.531-.743.853-1.421L5.42 7.849A1.6 1.6 0 1 1 7.68 5.584l9.617 9.617a.8.8 0 1 0 1.131-1.131l-2.828-2.829a1.6 1.6 0 1 1 2.263-2.262l2.828 2.828a.8.8 0 1 0 1.131-1.131L20.126 8.98a1.6 1.6 0 0 1 2.263-2.263l2.829 2.828a.8.8 0 1 0 1.13-1.131l-1.696-1.697a1.6 1.6 0 0 1 2.263-2.263l3.96 3.96c3.704 3.705 4.972 9.498 7.919 12.445a.8.8 0 1 0 1.131-1.131c-2.539-2.54-4.2-8.726-7.92-12.446l-3.96-3.96a3.2 3.2 0 0 0-5.401 1.641 3.201 3.201 0 0 0-3.649.622z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.15 13.104a6.4 6.4 0 1 1 6.788-6.788L9.943 3.323a4.8 4.8 0 1 0-6.788 6.788l2.993 2.993z"
});

var SvgPointer = function SvgPointer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 41,
    height: 32,
    viewBox: "0 0 41 32",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPointer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pointer.1c45a5f1.svg";
export { ForwardRef as ReactComponent };